// extracted by mini-css-extract-plugin
export default {"problemsSection":"Problems_problemsSection-OL0","problemsTitle":"Problems_problemsTitle-XeS","problemsList":"Problems_problemsList-IEx"};